<script lang="ts">
  import type { SkillCategory, SkillCategorySummary } from '$lib/api/types';

  interface Props {
    skillCat: SkillCategory;
    progress?: SkillCategorySummary;
  }

  let { skillCat, progress }: Props = $props();
</script>

<span>
  <img
    alt="badge for skill category {skillCat.name}"
    src={skillCat.badge}
    class="inline-badge"
    class:incomplete={(progress?.completedSkillCount ?? 0) !== skillCat.skills.length}
  />
  {skillCat.name}: {progress?.completedSkillCount ?? 0}/{skillCat.skills.length}
</span>

<style>
  .inline-badge {
    width: 1.5em;
    height: 1.5em;
  }

  .inline-badge.incomplete {
    filter: grayscale();
  }
</style>